export function setAccountComparsion(state, account_comparsion){
    state.account_comparsion = account_comparsion
}


// WEBPACK FOOTER //
// ./src/modules/account-comparison/mutations.js